import React from "react";
import { useLanguage } from "../../context/LanguageContext";

const TEAM_IMG =
  "https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwdGVhbXxlbnwwfHx8fDE3Nzk2MjQ2MjZ8MA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  const { t } = useLanguage();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 border-t border-slate-800 bg-[#0B1221]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative aspect-square w-full overflow-hidden border border-slate-800">
              <img
                src={TEAM_IMG}
                alt="Software development team"
                className="w-full h-full object-cover grayscale-[40%]"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-slate-950/70 via-transparent to-blue-900/20" aria-hidden="true" />
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <p
              className="text-[11px] tracking-[0.2em] uppercase text-blue-400 mb-5"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              {t.about.overline}
            </p>
            <h2
              className="text-3xl md:text-5xl font-bold tracking-tight text-slate-50 leading-tight"
              style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
              data-testid="about-title"
            >
              {t.about.title}
            </h2>
            <div
              className="mt-6 space-y-5 text-base md:text-lg text-slate-400 leading-relaxed max-w-2xl"
              style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
            >
              <p data-testid="about-paragraph-1">{t.about.paragraph1}</p>
              <p data-testid="about-paragraph-2">{t.about.paragraph2}</p>
            </div>

            <div className="mt-10 grid grid-cols-3 border-t border-slate-800">
              {t.about.stats.map((s, i) => (
                <div
                  key={i}
                  data-testid={`about-stat-${i}`}
                  className={`py-6 md:py-8 ${i !== 0 ? "pl-4 md:pl-8 border-l border-slate-800" : ""}`}
                >
                  <p
                    className="text-2xl md:text-3xl font-bold text-slate-50 tracking-tight"
                    style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
                  >
                    {s.value}
                  </p>
                  <p
                    className="mt-1.5 text-xs md:text-sm text-slate-400"
                    style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
                  >
                    {s.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
